import MainButton from 'global-styles/MainButton';
import { ReceiverIcon } from 'assets/icons';
import { H2, H2KR, BBINDIGO } from 'global-styles';
import { useContactModal } from 'hooks/useContactModal';
import React from 'react';
import styled from 'styled-components';

interface Props {
  locale: string;
}

const ProductContactUs = ({ locale }: Props) => {
  const { handleMoveToContactUsPage } = useContactModal();
  return (
    <ProductContactUsContainer>
      {locale === 'en' ? (
        <>
          <H2 as="p">Inquiry For more information,</H2>
          <H2 as="p">please contact us.</H2>
        </>
      ) : (
        <>
          <H2KR as="p">제품·기술과 관련된</H2KR>
          <H2KR as="p">궁금한 점이 있으시면 문의를 남겨주세요.</H2KR>
        </>
      )}
      <MainButton
        buttonType="default-w"
        text={locale === 'en' ? 'Contact Us' : '문의하러 가기'}
        icon={<ReceiverIcon />}
        iconPosition="left"
        style={{
          marginTop: '32px',
          width: '328px',
          height: '48px',
        }}
        onClick={handleMoveToContactUsPage}
      />
    </ProductContactUsContainer>
  );
};

export default ProductContactUs;

const ProductContactUsContainer = styled.article`
  width: 100%;
  padding: 103.5px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${BBINDIGO};
  text-align: center;
  color: #fff;

  @media screen and (max-width: 1239px) {
    padding: 56px 16px;
  }
`;
